import React from "react";
// javascript plugin used to create scrollbars on windows
// import PerfectScrollbar from "perfect-scrollbar";

import { connect } from "react-redux";
import { authActions } from "modules/auth/actions";

import { UserSidebar } from "./UserSidebar";
import MenuSidebar from "./MenuSidebar";

class Sidebar extends React.Component {
  getCalendarShortName = () => {
    let cal = this.props.school.calendars.find(
      (cal) => cal.calendar_id === this.props.currentCalendarID,
    );
    return cal.short_name;
  };
  render() {
    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <div className="logo">
          <a href="/" className="simple-text logo-mini">
            <div className="logo-img">
              <img src={this.props.school.image} alt="react-logo" />
            </div>
          </a>
          <a href="/" style={{ textDecoration: "none" }}>
            <span className="simple-text logo-normal">
              Alumni
              {this.getCalendarShortName() !== "2026" && (
                <> [Año {this.getCalendarShortName()}]</>
              )}
            </span>
          </a>
        </div>

        <div className="sidebar-wrapper" ref="sidebar">
          <UserSidebar user={this.props.user} logout={this.props.logout} />

          <MenuSidebar
            {...this.props}
            userRoles={this.props.roles}
            routes={this.props.routes}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.session.user,
    roles: state.auth.session.userRoles,
    school: state.config.school,
    currentCalendarID: state.school.currentCalendarID,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(authActions.logout());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
